cb.define(['common/common_VM.Extend.js'], function (common) {
    //String转换Int（位运算）
    var setCheckBoxEnum = function (data) {

        if (data != undefined) {
            var oldData = data.split(",");
            var result = 0;
            if (oldData != "") {
                oldData.forEach(function (item, index) {
                    result += Math.pow(2, parseInt(item) - 1);
                });
            }
            return result;
        } else {
            return 0;
        }

    };

    //InputNum控件限制类型
    var LIMIT_CATEGORY = {

        "MIN": 0,//最小值
        "MAX": 1//最大值

    };

    /**
     * 获取table所有数据
     * @param  viewmodel
     */
    var getthisdata = function (viewmodel) {
        var rows = viewmodel.get('combinationProducts').getRows();
        return rows;
    };
    /**
     * 获取tag的table所有数据
     **/
    var getTagData = function (viewmodel) {
        var rows = viewmodel.get('combinationActiveTag').getRows();
        return rows;
    };

    /**
     * 算总套餐价
     * @param  viewmodel
     */
    var getsum = function (viewmodel) {
        var sum = 0;
        let rows = getthisdata(viewmodel);
        for (var i = 0; i < rows.length; i++) {
            sum += parseFloat(rows[i].favorablePrice) || 0;
        }
        return sum;
    };

    /**
     * 算Tag总套餐价
     * @param  viewmodel
     */
    var getTagSum = function (viewmodel) {
        var sum = 0;
        let tagRows = getTagData(viewmodel);
        for (var i = 0; i < tagRows.length; i++) {
            sum += parseFloat(tagRows[i].tagPrice) || 0;
        }
        return sum;
    };

    /**
     * 算总商品原价
     * @param  viewmodel
     */
    var getTotalPrice = function (viewmodel) {
      var sum = 0;
      let rows = getthisdata(viewmodel);
      for (var i = 0; i < rows.length; i++) {
        if (null != rows[i].price && rows[i].iProductNum != null) {
          sum += parseFloat((parseFloat(rows[i].price) * rows[i].iProductNum).toFixed(2)) || 0;
        }
      }
      return sum;
    }

    /**
     * 算Tag总商品原价
     * @param  viewmodel
     */
    var getTagTotalPrice = function (viewmodel) {
        let minSum = 0;
        let maxSum = 0;

        let tagRows = getTagData(viewmodel);
        for (var i = 0; i < tagRows.length; i++) {
            let data = tagRows[i];
            minSum += parseFloat(data.iminprice) || 0;
            maxSum += parseFloat(data.imaxprice) || 0;
        }

        return minSum + '~' + maxSum;
    };
    var isZero =false;
    var PM_pmc_fixedsales_VM_Extend = {
        doAction: function (name, viewmodel) {
            if (this[name])
                this[name](viewmodel);
        },

        init: function (viewmodel) {
            //子表在卡片中显示需要加一行对应
            //viewmodel.get("combinationProducts").setState('defaultSelectedRowIndexes', true);
            viewmodel.get('cMonthDays').setState('min', 1);
            viewmodel.get('cMonthDays').setState('max', 31);
            var nowDates = new Date().format('yyyy-MM-dd hh:mm:ss');
            let mode = viewmodel.getParams().mode;

            /**
             * 设置控件最大最小值
             */
            const displaymMinPriceFromSub = (value) => {
                // let isDisabled = data.value.value == "false" ? false : true;
                if ((viewmodel.get('mainPriceFromSub').getValue() == true || viewmodel.get('mainPriceFromSub').getValue() == 'true')
                    && viewmodel.get('mainProductId').getValue()) {
                    viewmodel.get('combinationProducts').setColumnState('proportion', 'bIsNull', true);
                    viewmodel.get('combinationProducts').setColumnState('proportion', 'bCanModify', false);
                    if (value) {
                        let alldatas = getthisdata(viewmodel);
                        for (var i = 0; i < alldatas.length; i++) {
                            viewmodel.get('combinationProducts').setCellValue(i, 'proportion', null);
                        }
                    }
                } else {
                    viewmodel.get('combinationProducts').setColumnState('proportion', 'bIsNull', false);
                    viewmodel.get('combinationProducts').setColumnState('proportion', 'bCanModify', true);
                }
            }

            const displayPrice = (viewmodel) => {
                //仅勾线下门店
                if (viewmodel.get('applyOnlineChannel').getValue() == 0 && viewmodel.get('applyOffLineChannel').getValue() == 1) {
                    let pro_refCode = "pmc_product";
                    let sku_refCode = "aa_productsku";
                    let pro_refRetId = {
                        "productId": "id",
                        "productName": "cName",
                        "sProductCode": "code",
                        "price": "fMarkPrice",
                        "productPicUrl": "url",
                        "iShopId": "shopId",
                        "skuDescription": "modelDescription"
                    }
                    let sku_refRetId = {
                        "productId": "id",
                        "iskuId": "productskus_id",
                        "productName": "productName",
                        "sProductCode": "productCode",
                        "sProductSkuName": "name",
                        "sProductSkuCode": "code",
                        "price": "fMarkPrice",
                        "productPicUrl": "productUrl",
                        "iShopId": "shopId",
                        "skuDescription": "specs"
                    };
                    viewmodel.get("combinationProducts").getEditRowModel().get("sProductCode").setRefCode(pro_refCode, JSON.stringify(pro_refRetId));
                    viewmodel.get("combinationProducts").getEditRowModel().get("sProductSkuCode").setRefCode(sku_refCode, JSON.stringify(sku_refRetId));
                } else {
                    let pro_refCode = "pmc_product";
                    let sku_refCode = "aa_productsku";
                    let pro_refRetId = {
                        "productId": "id",
                        "productName": "cName",
                        "sProductCode": "code",
                        "price": "fSalePrice",
                        "productPicUrl": "url",
                        "iShopId": "shopId",
                        "skuDescription": "modelDescription"
                    }
                    let sku_refRetId = {
                        "productId": "id",
                        "iskuId": "productskus_id",
                        "productName": "productName",
                        "sProductCode": "productCode",
                        "sProductSkuName": "name",
                        "sProductSkuCode": "code",
                        "price": "salePrice",
                        "productPicUrl": "productUrl",
                        "iShopId": "shopId",
                        "skuDescription": "specs"
                    };
                    viewmodel.get("combinationProducts").getEditRowModel().get("sProductCode").setRefCode(pro_refCode, JSON.stringify(pro_refRetId));
                    viewmodel.get("combinationProducts").getEditRowModel().get("sProductSkuCode").setRefCode(sku_refCode, JSON.stringify(sku_refRetId));
                }
            }
            //区域控制
            const displayiAreaId = (viewmodel) => {
                delPro();
                let iRange = viewmodel.get("iRange").getValue();
                //平台
                if (iRange == 0) {
                    // viewmodel.get('btnBatchOp').setVisible(true);
                    viewmodel.get("iAreaId").setVisible(false);
                    viewmodel.get("iAreaId").setValue(null);
                } else {
                    viewmodel.get("iAreaId").setVisible(true);
                    // viewmodel.get('btnBatchOp').setVisible(false);
                }
            }
            viewmodel.get('iAreaId').on('afterValueChange', function (data) {
                common.displayArea(viewmodel);
                delPro();
            });
            viewmodel.get("iRange").on('afterValueChange', () => {
                displayiAreaId(viewmodel);
            })

            viewmodel.get('memberLevelAll').on('afterValueChange', () => {
                displayIsGetmemberPrice(viewmodel);
            })

            viewmodel.get('iPackageDiscountSelect').on('afterValueChange', () => {
                handleDiscountPackage(viewmodel);
            })


            viewmodel.get("combinationsalesmemberlevel").on('afterValueChange', () => {
                displayIsGetmemberPrice(viewmodel);
            })

            viewmodel.get("mainProduct_Name").on('beforeBrowse', function () {
                let areaId;
                if (viewmodel.get("iRange") && viewmodel.get("iRange").getValue() == 1) {
                    if (!viewmodel.get("iAreaId").getValue()) {
                        cb.utils.alert('请选择适用区域', 'warning');
                        return false;
                    } else {
                        areaId = viewmodel.get("iAreaId").getValue();
                    }
                }
                let mainProductId = viewmodel.get("mainProductId").getValue();
                if (areaId) {
                    let externalData = {"areaId": areaId};
                    this.setState('externalData', externalData);
                }
                let condition = {
                    "isExtend": true,
                    simpleVOs: []
                };

                //没有选主商品
                if (!mainProductId) {
                    common.addProductReferCondition(viewmodel, false, condition, null, null, true);
                } else {
                    common.addProductReferCondition(viewmodel, false, condition, null, null, true);
                    condition.simpleVOs.push({
                        field: 'id',
                        op: 'eq',
                        value1: mainProductId
                    });
                }
                this.setFilter(condition);
                return true;
            });

            viewmodel.get("iskuId_Name").on('beforeBrowse', function () {
                let areaId;
                if (viewmodel.get("iRange") && viewmodel.get("iRange").getValue() == 1) {
                    if (!viewmodel.get("iAreaId").getValue()) {
                        cb.utils.alert('请选择适用区域', 'warning');
                        return false;
                    } else {
                        areaId = viewmodel.get("iAreaId").getValue();
                    }
                }
                let mainProductSkuId = viewmodel.get("iskuId").getValue();
                if (areaId) {
                    let externalData = {"areaId": areaId};
                    this.setState('externalData', externalData);
                }
                let condition = {
                    "isExtend": true,
                    simpleVOs: []
                };
                //没有选主商品
                if (!mainProductSkuId) {
                    common.addProductReferCondition(viewmodel, true, condition, null, null, true);
                } else {
                    common.addProductReferCondition(viewmodel, true, condition, null, null, true);
                    condition.simpleVOs.push({
                        field: 'id',
                        op: 'eq',
                        value1: mainProductSkuId
                    });
                }
                this.setFilter(condition);
                return true;
            });

            viewmodel.get('mainType').on('afterValueChange', (args) => {
                // if (args.value) {
                //     //商品
                //     if (args.value.value == 1) {
                //         viewmodel.get('iskuId_Name').setValue(null);
                //         viewmodel.get('iskuId_price').setValue(null);
                //         viewmodel.get('skuDescription').setValue(null);
                //         viewmodel.get('iskuId_url').setValue(null);
                //         viewmodel.get("iskuId").setValue(null);
                //         viewmodel.get("iskuId_Code").setValue(null);
                //         viewmodel.get('mainProductId').setValue(null);
                //         viewmodel.get("mainProductCode").setValue(null);
                //     } else {
                //         viewmodel.get('mainProduct_Name').setValue(null);
                //         viewmodel.get('mainProductId_price').setValue(null);
                //         viewmodel.get('mainProductId_modelDescription').setValue(null);
                //         viewmodel.get('mainProductId_url').setValue(null);
                //         viewmodel.get('mainProductId').setValue(null);
                //         viewmodel.get("mainProductCode").setValue(null);
                //     }
                // }
                clearMainType(viewmodel);
                displayMainType(viewmodel);
            })

            viewmodel.on('beforeEdit', function (data) {
                return common.checkAuth(viewmodel.originalParams.id, 'pmc_fixedsales');
            })

            viewmodel.on("modeChange", function (data) {
                if (data == "edit") {
                    let onlyOffline = viewmodel.get('applyOnlineChannel').getValue() == 0 && viewmodel.get('applyOffLineChannel').getValue() == 1;
                    handleLineTableDiv(onlyOffline);
                    common.displayArea(viewmodel);
                }
            })

            viewmodel.get("mainPriceFromSub").on('afterValueChange', (data) => {
                displaymMinPriceFromSub(true);
            })
            //处理主商品变更逻辑
            viewmodel.get("mainProduct_Name").on('afterValueChange', (data) => {
                displayIsincludeMainProduct(data.value);
                //处理套餐处理方式
                handleDiscountPackage(viewmodel);
                let applyOnlineChannel = viewmodel.get('applyOnlineChannel').getValue();
                let applyOfflineChannel = viewmodel.get('applyOffLineChannel').getValue();
                if (applyOnlineChannel == 0 && applyOfflineChannel == 1 && (!data.value || data.value.length == 0)) {
                    settintPackageDiscountSelect(false);
                } else {
                    settintPackageDiscountSelect(true);
                }
                if (data.value) {
                    displaymMinPriceFromSub(true);
                }
            })

            //处理主商品SKU变更逻辑
            viewmodel.get("iskuId_Name").on('afterValueChange', (data) => {
                displayIsincludeMainProduct(data.value);
                //处理套餐处理方式
                handleDiscountPackage(viewmodel);
                let applyOnlineChannel = viewmodel.get('applyOnlineChannel').getValue();
                let applyOfflineChannel = viewmodel.get('applyOffLineChannel').getValue();
                if (applyOnlineChannel == 0 && applyOfflineChannel == 1 && (!data.value || data.value.length == 0)) {
                    settintPackageDiscountSelect(false);
                } else {
                    settintPackageDiscountSelect(true);
                }
                if (data.value) {
                    displaymMinPriceFromSub(true);
                }
            })

            viewmodel.get('applicableChannel').on('afterValueChange', function (data) {
                viewmodel.get('terminalType').setVisible(false);
                viewmodel.get('offLineStore').setVisible(false);
                viewmodel.get('combinationSalesStore').setVisible(false);
                viewmodel.get('applyOnlineChannel').setValue(false);
                viewmodel.get("iPackageLimitNum2").setState('iNumPoint', 0);
                viewmodel.get('applyOffLineChannel').setValue(false);
                viewmodel.get('iSendPoint').setVisible(false);
                viewmodel.get('mainPriceFromSub').setVisible(false);
                viewmodel.get('subProductMustOnSale').setVisible(false);
                var on = 0;
                for (var i = 0; i < data.value.length; i++) {
                    if (data.value[i].value == 0) {
                        viewmodel.get('terminalType').setVisible(true);
                        viewmodel.get('applyOnlineChannel').setValue(true);
                        viewmodel.get("iPackageLimitNum2").setState('iNumPoint', 0);
                        viewmodel.get('iSendPoint').setVisible(false);
                        viewmodel.get('mainPriceFromSub').setVisible(false);
                        viewmodel.get('subProductMustOnSale').setVisible(false);
                        on = 1;
                    } else if (data.value[i].value == 1) {
                        viewmodel.get('applyOffLineChannel').setValue(true);
                        viewmodel.get('offLineStore').setVisible(true);
                        if (viewmodel.get('promotionParams')) {
                            let userType = viewmodel.get('promotionParams').userType;
                            //超级管理员
                            if (userType != 0 && viewmodel.get('offLineStore').getValue() == 1) {
                                viewmodel.get('offLineStore').setValue(2);
                            }
                        }
                        if (viewmodel.get('offLineStore').getValue() == 1) {
                            viewmodel.get('combinationSalesStore').setVisible(false);
                        } else {
                            viewmodel.get('combinationSalesStore').setVisible(true);
                        }
                        if (on == 0) {
                            viewmodel.get("iPackageLimitNum2").setState('iNumPoint', 2);
                            viewmodel.get('iSendPoint').setVisible(true);
                            viewmodel.get('mainPriceFromSub').setVisible(true);
                            viewmodel.get('subProductMustOnSale').setVisible(true);
                            //如果未选择线上商城，仅选择了线下门店
                            on = 2;
                        }
                    }
                }
                //只有线下门店时并且没选择主商品才允许选择“套餐折扣”选项
                settintPackageDiscountSelect(on == 2 && !viewmodel.get("mainProductId").getValue() ? false : true);

                //处理显示哪个table，为2表示只选择了“线下门店”
                handleLineTableDiv(on == 2 ? true : false);

                //处理主商品是否可选择
                isDisabledMainProduct(on == 2 ? true : false);

                handleDiscountPackage(viewmodel);

                if (on != 2) {
                    //如果不是只选择线下门店，删除促销列表下的相关行
                    viewmodel.get('mainPriceFromSub').setValue(false);
                    viewmodel.get('subProductMustOnSale').setVisible(false);
                    delTagPro();
                }
                displayMainTypeControl(viewmodel);
                clearMainType(viewmodel);
                displayPrice(viewmodel);
            });
            viewmodel.get('activityMode').on('afterValueChange', function () {
                common.displayActivityMode(viewmodel);
            });

            //清除全部商品
            viewmodel.on('batchProDelete', function (args) {
                debugger
                let counts = viewmodel.get('combinationProducts').getRowsCount();
                var rowIndexes = [];
                for (let i = counts - 1; i >= 0; i--) {
                    rowIndexes.push(i);
                }
                viewmodel.get("combinationProducts").deleteRows(rowIndexes);
            })

            viewmodel.on('afterLoadData', function (data) {
                viewmodel.get('mainProductId_price').setDisabled(true);
                viewmodel.get('mainProductId_modelDescription').setDisabled(true);
                viewmodel.get('mainProductCode').setDisabled(true);
                viewmodel.get('iskuId_price').setDisabled(true);
                viewmodel.get('skuDescription').setDisabled(true);
                viewmodel.get('iskuId_Code').setDisabled(true);
                displaymMinPriceFromSub(false);
                common.hideNoStore(viewmodel);
                if (viewmodel.get('iskuId').getValue() && viewmodel.get('iskuId').getValue() != 0) {
                    viewmodel.get('mainType').setValue(2);
                } else {
                    viewmodel.get('mainType').setValue(1);
                }
                displayMainType(viewmodel);
                displayPrice(viewmodel);
                common.displayActivityMode(viewmodel);
                common.displayChannel(viewmodel, 'fixedsales');
                common.displayArea(viewmodel);
                common.displayEditButton(viewmodel, "valid");
                displayIsGetmemberPrice(viewmodel);
                displayMainTypeControl(viewmodel);
                dealApplyOnlineChannel();

                //判断是否包含主商品
                displayIsincludeMainProduct(data.mainProductId);

                //处理是否禁用选择主商品
                whetherToDisableMainProduct(viewmodel);

                //处理套餐处理方式
                handleDiscountPackage(viewmodel);

                //处理促销标签原价
                handlePromotionTagPrice(data);

                //增加InputNum限制
                setViewLimits();

                if (null == data.mainProductId && data.iPackageDiscountSelect == true) {
                    //显示套餐折扣
                    if (null != data.combinationProducts) {
                        data.combinationProducts.forEach(function (item, index) {
                            viewmodel.get('combinationProducts').setCellValue(index, 'discountPackage', item.favorablePrice);
                        })
                    }

                }

                //控制显示和隐藏
                if (this.get('applyOnlineChannel').getValue() == false) {
                    viewmodel.get('terminalType').setVisible(false);
                } else {
                    viewmodel.get('terminalType').setVisible(true);
                }

                //线下
                if (this.get('applyOffLineChannel').getValue() == false) {
                    viewmodel.get('offLineStore').setVisible(false);
                    viewmodel.get('combinationSalesStore').setVisible(false);
                } else {
                    viewmodel.get('offLineStore').setVisible(true);
                    if (this.get('offLineStore').getValue() == 1 || this.get('offLineStore').getValue() == 0) {
                        viewmodel.get('combinationSalesStore').setVisible(false);
                    } else {
                        viewmodel.get('combinationSalesStore').setVisible(true);
                    }
                }
                if (this.get('memberLevelAll').getValue() == 0) {
                    viewmodel.get('combinationsalesmemberlevel').setVisible(true);
                } else {
                    viewmodel.get('combinationsalesmemberlevel').setVisible(false);
                }


                if (this.get('combinationProducts').getEditRowModel().get('type').getValue() != 4) {
                    viewmodel.get('combinationProducts').getEditRowModel().get('typeNum').setVisible(false);
                } else {
                    viewmodel.get('combinationProducts').getEditRowModel().get('typeNum').setVisible(true);
                }

                if (this.getParams().mode === 'add') {
                    //子表在卡片中显示需要加一行对应
                    // viewmodel.get("combinationProducts").appendRow();
                } else if (this.getParams().mode === 'edit') {

                }

            });

            /**点击按钮弹出参照前事件
             *返回true则继续进行弹出参照操作，返回false则终止弹出
             */
            viewmodel.get("combinationSalesStore").on('beforeBrowse', function () {
                return true;
            });

            viewmodel.get("memberLevelAll").on('beforeBrowse', function () {
                return true;
            });

            //控制字段是否可修改  false：不可修改
            viewmodel.get('combinationProducts').on('rowColChange', function (data) {
                if (data.value.columnKey == 'skuDescription') {
                    if (this.getCellValue(data.value.rowIndex, 'productName') != null) {
                        return false;
                    }
                }
                if (data.value.columnKey == 'productName') {
                    if (this.getCellValue(data.value.rowIndex, 'skuDescription') != null) {
                        return false;
                    }
                    if (this.getCellValue(data.value.rowIndex, 'productName') != null) {
                        return false;
                    }
                }
            });

            viewmodel.get("combinationProducts").on("beforeBrowse", function (data) {
                let mainProductCode = viewmodel.get("mainProductCode").getValue();
                let banIds;
                if (mainProductCode) {
                    banIds = [];
                    banIds.push(mainProductCode);
                }
                let areaId;
                if (viewmodel.get("iRange") && viewmodel.get("iRange").getValue() == 1) {
                    if (!viewmodel.get("iAreaId").getValue()) {
                        cb.utils.alert('请选择适用区域', 'warning');
                        return false;
                    } else {
                        areaId = viewmodel.get("iAreaId").getValue();
                    }
                }
                common.productReferBrowse(viewmodel, data, "sProductCode", "sProductSkuCode", "iskuId",
                    "combinationProducts", 'memberLevelAll', 'isGetmemberPrice',
                    "combinationsalesmemberlevel", "lMemberLeverId", false, banIds, areaId);
                if (data.context.getFilter() && data.context.getFilter().simpleVOs) {
                    let orConditions = [];
                    //查某个字段不等于某个值时，平台会在这个字段不为null的基础条件上去过滤
                    if (data.cellName == 'sProductSkuCode') {
                        orConditions.push({
                            field: 'productId.virtualProductAttribute',
                            op: 'neq',
                            value1: 9
                        });
                        orConditions.push({
                            field: 'productId.virtualProductAttribute',
                            op: 'is_null',
                        });
                    } else {
                        orConditions.push({
                            field: 'virtualProductAttribute',
                            op: 'neq',
                            value1: 9
                        });
                        orConditions.push({
                            field: 'virtualProductAttribute',
                            op: 'is_null',
                        });
                    }
                    data.context.getFilter().simpleVOs.push({
                        "logicOp": "or",
                        "conditions": orConditions
                    });
                }
                return true;
            })

            viewmodel.get('PackageDiscountDrice').on('afterValueChange', function (data) {

                //处理活动商品
                var alldata = getthisdata(viewmodel);
                var prices = 0;
                for (var i = 0; i < alldata.length; i++) {
                    prices += alldata[i].price * alldata[i].iProductNum;
                }

              var sum = 0;
              for (var j = 0; j < alldata.length; j++) {
                    if (alldata[j].productId != null) {
                      if (j !== alldata.length - 1) {
                          let favorablePrice = (alldata[j].price * alldata[j].iProductNum / prices * data.value).toFixed(2);
                          viewmodel.get('combinationProducts').setCellValue(j, 'favorablePrice', favorablePrice);
                          sum += parseFloat(favorablePrice) || 0;
                      }else {
                          let favorablePrice = (data.value - sum).toFixed(2);
                          viewmodel.get('combinationProducts').setCellValue(j, 'favorablePrice', favorablePrice);
                      }
                    }
                }

                // //处理促销标签(暂不处理商品标签，原价比例无法计算)
                // var allTagdata = getTagData(viewmodel);
                // var tagPrices = 0;
                // for (var i = 0; i < allTagdata.length; i++) {
                //     tagPrices += allTagdata[i].tagPrice;
                // }

                // for (var j = 0; j < allTagdata.length; j++) {
                //     let tagPrice = (allTagdata[j].tagPrice / tagPrices * data.value).toFixed(2);
                //     viewmodel.get('combinationActiveTag').setCellValue(j, 'tagPrice', tagPrice);
                // }
            })

            viewmodel.get('iPackageLimitNum').on('afterValueChange', function (data) {
                isDisplayPackageLimitNum2(data.value.value);
            })
            //单元格数据改变处理
            viewmodel.get('combinationProducts').on('afterCellValueChange', function (data) {

                //删除Tag的table中的数据
                delTagPro();

                if (data.cellName == 'sProductSkuCode') {
                    //设置总原价
                    viewmodel.get('totalPrice').setValue(getTotalPrice(viewmodel));
                    //设置总套餐价
                    viewmodel.get('PackageDiscountDrice').setValue(getsum(viewmodel));
                }

                if (data.cellName == 'favorablePrice') {
                    viewmodel.get('PackageDiscountDrice').setValue(getsum(viewmodel));
                }

                if (data.cellName == 'sProductCode') {
                    this.setCellValue(data.rowIndex, 'iskuId', 0);
                    this.setCellValue(data.rowIndex, 'sProductSkuName', null);
                    this.setCellValue(data.rowIndex, 'sProductSkuCode', null);
                    viewmodel.get('totalPrice').setValue(getTotalPrice(viewmodel));
                }

                if (data.cellName == 'iProductNum') {
                    //设置总原价
                    viewmodel.get('totalPrice').setValue(getTotalPrice(viewmodel));
                    //设置总套餐价
                    viewmodel.get('PackageDiscountDrice').setValue(getsum(viewmodel));
                }

                if (data.cellName == 'totalFavorablePrice') {
                    viewmodel.get('combinationProducts').setColumnValue('totalFavorablePrice', data.value);
                    var alldata = getthisdata(viewmodel);
                    var prices = 0;
                    for (var i = 0; i < alldata.length; i++) {
                        prices += alldata[i].price;
                    }
                    for (var j = 0; j < alldata.length; j++) {
                        //alldata[j].favorablePrice=alldata[j].price/prices*data.value;
                        viewmodel.get('combinationProducts').setCellValue(j, 'favorablePrice', (alldata[j].price / prices * data.value).toFixed(2));
                    }
                }

            });

            //增行处理
            viewmodel.get('combinationProducts').on('afterInsertRow', function (rows) {

                viewmodel.get('PackageDiscountDrice').setValue(getsum(viewmodel));
                viewmodel.get('totalPrice').setValue(getTotalPrice(viewmodel));

                viewmodel.get('iPackageLimitNum').setValue(viewmodel.get('iPackageLimitNum').getValue());
                viewmodel.get('iPackageLimitNum2').setValue(viewmodel.get('iPackageLimitNum2').getValue());

                //判断总行数是否大于0，大于0并且主商品为空
                if (0 < viewmodel.get('combinationProducts').getRowsCount()
                    && (viewmodel.get('mainProductId').getValue() == null)
                    && ((viewmodel.get('mainProduct_Name').getDisabled() == null) || (viewmodel.get('mainProduct_Name').getDisabled() == false))) {
                    viewmodel.get('mainProduct_Name').setDisabled(true);
                }
            });

            //删行数据处理
            viewmodel.get('combinationProducts').on('afterDeleteRows', function (rows) {

                viewmodel.get('PackageDiscountDrice').setValue(getsum(viewmodel));
                viewmodel.get('totalPrice').setValue(getTotalPrice(viewmodel));

                //判断总行数是否为0，为0时将选择主商品启用
                if (0 == viewmodel.get('combinationProducts').getRowsCount()
                    && viewmodel.get('combinationActiveTag').getRowsCount() == 0) {
                    viewmodel.get('mainProduct_Name').setDisabled(false);
                }
            });

            //商品标签单元格数据改变处理
            viewmodel.get('combinationActiveTag').on('afterCellValueChange', function (data) {

                //删除table中的数据
                delPro();

                if (data.cellName == 'tagPrice') {
                    viewmodel.get('PackageDiscountDrice').setValue(getTagSum(viewmodel));
                }

                if (data.cellName == 'type') {
                    //设置tag总原价
                    viewmodel.get('totalPrice').setValue(getTagTotalPrice(viewmodel));
                    //设置tag总套餐价
                    viewmodel.get('PackageDiscountDrice').setValue(getTagSum(viewmodel));
                }

                if (data.cellName === 'cTagName') {

                    var selectedTagIds = viewmodel.get('combinationActiveTag').getCellValue(data.rowIndex, 'iTagId');
                    var url = '/product/getTagPrice';
                    var proxy = cb.rest.DynamicProxy.create({
                        ensure: {
                            url: url,
                            method: 'POST'
                        }
                    });
                    var datas = [];
                    datas.push({
                        "ids": selectedTagIds,
                    });
                    var params = {
                        billnum: "pmc_combinationsales",
                        data: JSON.stringify(datas)
                    }
                    proxy.ensure(params, function (err, result) {
                        if (err) {
                            cb.utils.alert(err.message, 'error');
                            return;
                        }
                        if (result) {
                            if (result.minPrice <= result.maxPrice) {
                                viewmodel.get('combinationActiveTag').setCellValue(data.rowIndex, 'price', result.minPrice + "~" + result.maxPrice);
                                viewmodel.get('combinationActiveTag').setCellValue(data.rowIndex, 'iminprice', result.minPrice);
                                viewmodel.get('combinationActiveTag').setCellValue(data.rowIndex, 'imaxprice', result.maxPrice);
                            } else {
                                viewmodel.get('combinationActiveTag').setCellValue(data.rowIndex, 'price', '');
                                viewmodel.get('combinationActiveTag').setCellValue(data.rowIndex, 'iminprice', 0);
                                viewmodel.get('combinationActiveTag').setCellValue(data.rowIndex, 'imaxprice', 0);
                            }
                            //设置tag总原价
                            viewmodel.get('totalPrice').setValue(getTagTotalPrice(viewmodel));
                        }
                        //viewmodel.execute('refresh');
                    });
                }

            });

            //商品标签增行处理
            viewmodel.get('combinationActiveTag').on('afterInsertRow', function (rows) {

                viewmodel.get('PackageDiscountDrice').setValue(getTagSum(viewmodel));
                viewmodel.get('totalPrice').setValue(getTagTotalPrice(viewmodel));

                viewmodel.get('iPackageLimitNum').setValue(viewmodel.get('iPackageLimitNum').getValue());
                viewmodel.get('iPackageLimitNum2').setValue(viewmodel.get('iPackageLimitNum2').getValue());

                //判断总行数是否大于0，大于0并且主商品为空
                if (0 < viewmodel.get('combinationActiveTag').getRowsCount()
                    && (viewmodel.get('mainProductId').getValue() == null)
                    && ((viewmodel.get('mainProduct_Name').getDisabled() == null) || (viewmodel.get('mainProduct_Name').getDisabled() == false))) {
                    viewmodel.get('mainProduct_Name').setDisabled(true);
                }
            });

            //商品标签删行数据处理
            viewmodel.get('combinationActiveTag').on('afterDeleteRows', function (rows) {

                viewmodel.get('PackageDiscountDrice').setValue(getsum(viewmodel));
                viewmodel.get('totalPrice').setValue(getTotalPrice(viewmodel));

                //判断总行数是否为0，为0时将选择主商品启用
                if (0 == viewmodel.get('combinationActiveTag').getRowsCount()
                    && viewmodel.get('combinationProducts').getRowsCount() == 0) {
                    viewmodel.get('mainProduct_Name').setDisabled(false);
                }
            });

            //是否适用线上终端控制事件
            viewmodel.get('applyOnlineChannel').on('afterValueChange', function (data) {
                if (data.value.value === '0') {
                    viewmodel.get("terminalType").setVisible(false);
                } else {
                    viewmodel.get("terminalType").setVisible(true);
                }
            });
            //是否适用线下终端控制事件
            viewmodel.get('applyOffLineChannel').on('afterValueChange', function (data) {

                if (data.value.value === '0') {
                    viewmodel.get('offLineStore').setVisible(false);
                    viewmodel.get("combinationSalesStore").setVisible(false);
                } else {
                    viewmodel.get('offLineStore').setVisible(true);
                    if (viewmodel.get('offLineStore').getValue() == '0') {
                        viewmodel.get('offLineStore').setValue(1);
                    }
                }
            });
            //买家范围控制事件
            viewmodel.get('memberLevelAll').on('afterValueChange', function (data) {
                if (data.value.value === '0') {
                    viewmodel.get("combinationsalesmemberlevel").setVisible(true);
                } else {
                    viewmodel.get('combinationsalesmemberlevel').setVisible(false);
                }
            });
            //线下门店控制事件
            viewmodel.get('offLineStore').on('afterValueChange', function (data) {

                if (data.value.value === '1') {
                    viewmodel.get("combinationSalesStore").setVisible(false);
                } else {
                    viewmodel.get('combinationSalesStore').setVisible(true);
                }
            });

            viewmodel.on('batchModifySetFields', function (args) {
                debugger
                args.forEach((item, index) => {
                    if (item.fieldName === 'proportion' || item.fieldName === 'type' || item.fieldName === 'typeNum') {
                        item.bCanModify = false;
                    } else if (item.fieldName === 'productPicUrl' || item.fieldName === 'productName' || item.fieldName === 'sProductSkuName'
                        || item.fieldName === 'price') {
                        item.bCanFilter = false;
                    } else if (item.fieldName === 'sProductCode' || item.fieldName === 'sProductSkuCode' || item.fieldName === 'favorablePrice'
                        || item.fieldName === 'iProductNum') {
                        item.bCanFilter = false;
                        item.bCanModify = false;
                    }
                })
            })

            viewmodel.get("mainProduct_Name").on('beforeValueChange', args => {
                common.mainURL(args, false);
            });

            viewmodel.get("iskuId_Name").on('beforeValueChange', args => {
                common.mainURL(args, true);
            });

            //保存前数据处理
            viewmodel.on('beforeSave', function (data) {

                var obj = JSON.parse(data.data.data);
                if (obj.combinationProducts && obj.combinationProducts.length > 0) {

                    for (let i = 0; i < obj.combinationProducts.length; i++) {
                        let item = obj.combinationProducts[i];
                        if (item._status == 'Delete') {
                            //如果为删除的则不校验
                            continue;
                        }
                        if (this.get('iPackageDiscountSelect').getValue() == 'false' || this.get('iPackageDiscountSelect').getValue() == false) {
                        //“套餐价设置方式”选择的为“套餐价”
                            if(isZero == false){
                                if (this.get('mainProductId').getValue() != null && item.proportion == 0 && (false == obj.mainPriceFromSub || "false" == obj.mainPriceFromSub)) {
                                    var returnPromise = new cb.promise();
                                    cb.utils.confirm('活动商品下的金额权重有为0的情况，是否保存', function () {
                                        isZero =true;
                                        viewmodel.biz.do('save', viewmodel);
                                        return;
                                    }, function () {
                                      returnPromise.reject();
                                    });
                                    return returnPromise;
                                }
                            }
                        }
                    }
                }
                isZero = false;
                obj.terminalType = setCheckBoxEnum(obj.terminalType);
                obj.activityType = setCheckBoxEnum(obj.activityType);
                obj.cMonthDays = String(obj.cMonthDays);
                if (viewmodel.get("iRange") && viewmodel.get("iRange").getValue() == 1) {
                    if (!viewmodel.get("iAreaId").getValue() || viewmodel.get("iAreaId").getValue() == 0) {
                        cb.utils.alert('请选择适用区域', 'warning');
                        return false;
                    }
                }
                if (this.get('applyOnlineChannel').getValue() == '1' && obj.terminalType == 0) {
                    cb.utils.alert('适用线上商城时，适用终端不可为空', 'warning');
                    return false;
                }

                if (this.get('memberLevelAll').getValue() == '0' && this.get('combinationsalesmemberlevel').getShowValue() == '') {
                    cb.utils.alert('指定会员不可为空', 'warning');
                    return false;
                } else if (this.get('memberLevelAll').getValue() != '0') {
                    obj.combinationsalesmemberlevel = [];
                }

                if (this.get('applyOffLineChannel').getValue() == '1' && this.get('offLineStore').getValue() != '1' && this.get('combinationSalesStore').getShowValue() == '') {
                    cb.utils.alert('指定门店不可为空', 'warning');
                    return false;
                } else if (this.get('applyOffLineChannel').getValue() == '0') {
                    obj.offLineStore = 1;
                    if (obj.memberLevelAll == 1) {
                        obj.memberLevelAll = 2;
                    }
                } else if (this.get('applyOffLineChannel').getValue() == '1' && this.get('offLineStore').getValue() == '1') {
                    obj.combinationSalesStore = [];
                } else if (this.get('applyOffLineChannel').getValue() == '1' && this.get('offLineStore').getValue() == '0') {
                    cb.utils.alert('线下门店不能为空', 'warning');
                    return false;
                }

                let totalRate = 0;
                //是否停止下一步操作
                let isStop = false;
                if (obj.combinationProducts) {
                    var prodata = obj.combinationProducts;
                    for (var i = 0; i < prodata.length; i++) {
                        if (prodata[i]._status == "Delete") {
                            continue;
                        }
                        if (prodata[i].productId == null) {
                            cb.utils.alert('商品编码不能为空', 'warning');
                            isStop = true;
                            return false;
                        }
                        if (viewmodel.get('mainProductId').getValue()) {
                            let isTrue = viewmodel.get('mainProductShop').getValue() != 0 && prodata[i].iShopId != viewmodel.get('mainProductShop').getValue();
                            if (isTrue) {
                                cb.utils.alert('第' + (i + 1) + '行商品与主商品的商家不符，请选择同一商家的商品', 'warning');
                                isStop = true;
                                return false;
                            }
                        } else {
                            if (i > 0) {
                                let exampleId = prodata[0].iShopId;
                                if (exampleId) {
                                    if (!prodata[i].iShopId) {
                                        cb.utils.alert('商品里不能同时存在商家商品和平台商品！', 'warning');
                                        isStop = true;
                                        return false;
                                    } else {
                                        if (exampleId != prodata[i].iShopId) {
                                            cb.utils.alert('商品里不能同时存在多商家商品！', 'warning');
                                            isStop = true;
                                            return false;
                                        }
                                    }
                                } else {
                                    if (exampleId != prodata[i].iShopId) {
                                        cb.utils.alert('商品里不能同时存在商家商品和平台商品！', 'warning');
                                        isStop = true;
                                        return false;
                                    }
                                }
                            }
                        }
                        if (prodata[i].price != null) {
                            prodata[i].newPrice = prodata[i].price;
                        }
                        if (prodata[i].discountPackage != null) {
                            prodata[i].favorablePrice = prodata[i].discountPackage;
                        }
                        totalRate += Number(prodata[i].proportion);
                    }
                }

                //如果参数验证出现问题，直接终止
                if (isStop) {
                    return false;
                }

                //验证各个参数是否为0
                if (this.get('mainProductId').getValue() == null) {
                    //未选择主商品
                    if (this.get('iPackageLimitNum').getValue() == null || this.get('iPackageLimitNum').getValue() == 0) {
                        cb.utils.alert('限购类型不能为空', 'warning');
                        return false;
                    }

                    let isTrue = this.get('iPackageLimitNum').getValue() == 4 && (this.get('iPackageLimitNum2').getValue() == null);
                    if (isTrue) {
                        cb.utils.alert('限购数量不能为空', 'warning');
                        return false;
                    }

                    isTrue = this.get('iPackageLimitNum').getValue() == 4 && this.get('iPackageLimitNum2').getValue() == 0;
                    if (isTrue) {
                        cb.utils.alert('限购数量不能为0', 'warning');
                        return false;
                    }
                }

                if (this.get('iPackageDiscountSelect').getValue() == 'false' || this.get('iPackageDiscountSelect').getValue() == false) {
                    //“套餐价设置方式”选择的为“套餐价”
                    if (this.get('mainProductId').getValue() == null) {
                        //未选择主商品
                        if (this.get('PackageDiscountDrice').getValue() == null) {
                            cb.utils.alert('套餐价不能为空', 'warning');
                            return false;
                        }
                        if (this.get('PackageDiscountDrice').getValue() == 0) {
                            cb.utils.alert('套餐价不能为0', 'warning');
                            return false;
                        }
                    }
                }

                if (this.get('cMonthDays').getValue() && this.get('cMonthDays').getValue() != '') {
                    obj.cMonthDays = ',' + obj.cMonthDays + ',';
                }

                if (this.get('cWeekDays').getValue() && this.get('cWeekDays').getValue() != '') {
                    obj.cWeekDays = ',' + obj.cWeekDays + ',';
                }
                //每天、每周、每月活动时间控制
                if (this.get('activityMode').getValue() == 1) {
                    if (!this.get('beginTime').getValue() || !this.get('endTime').getValue()) {
                        cb.utils.alert('每天活动时间不能为空', 'warning');
                        return false;
                    }
                    if (this.get('beginTime').getValue() >= this.get('endTime').getValue()) {
                        cb.utils.alert('每天活动开始时间必须小于结束时间', 'warning');
                        return false;
                    }
                } else if (this.get('activityMode').getValue() == 2) {
                    if (!this.get('cWeekBeginTime').getValue() || !this.get('cWeekEndTime').getValue() || !this.get('cWeekDays').getValue()) {
                        cb.utils.alert('每周活动时间不能为空', 'warning');
                        return false;
                    }
                    if (this.get('cWeekBeginTime').getValue() >= this.get('cWeekEndTime').getValue()) {
                        cb.utils.alert('每周活动开始时间必须小于结束时间', 'warning');
                        return false;
                    }
                } else if (this.get('activityMode').getValue() == 3) {
                    if (!this.get('cMonthDays').getValue() || !this.get('cMonthBeginTime').getValue() || !this.get('cMonthEndTime').getValue()) {
                        cb.utils.alert('每月活动时间不能为空', 'warning');
                        return false;
                    }
                    if (this.get('cMonthBeginTime').getValue() >= this.get('cMonthEndTime').getValue()) {
                        cb.utils.alert('每月活动开始时间必须小于结束时间', 'warning');
                        return false;
                    }
                }

                // if (mode == 'add') {
                //     if (viewmodel.get('startDate').getValue() <= nowDates) {
                //         cb.utils.alert('开始时间大于当前时间', 'warning');
                //         return false;
                //     }
                // }

                if (this.get('startDate').getValue() >= this.get('endDate').getValue()) {
                    cb.utils.alert('活动结束时间必须大于开始时间', 'warning');
                    return false;
                }
                if (this.get('combinationActiveTag').getRows().length == 0 && this.get('combinationProducts').getRows().length == 0) {
                    cb.utils.alert('请选取活动商品', 'warning');
                    return false;
                }

                if (obj.combinationProducts && obj.combinationProducts.length > 0) {
                    //活动商品列表数据不为空
                    let isStop = false;

                    let isDecimals = false;
                    let applicableChannel = viewmodel.get('applicableChannel').getValue();
                    for (let i = 0; i < applicableChannel.length; i++) {
                        if (applicableChannel[i] == '0') {
                            isDecimals = true;
                            break;
                        }
                    }

                    for (let i = 0; i < obj.combinationProducts.length; i++) {
                        let item = obj.combinationProducts[i];
                        if (item._status == 'Delete') {
                            //如果为删除的则不校验
                            continue;
                        }
                        if (this.get('iPackageDiscountSelect').getValue() == 'true' || this.get('iPackageDiscountSelect').getValue() == true) {
                            //“套餐价设置方式”选择的为“套餐折扣”
                            if (item.discountPackage == 0) {
                                cb.utils.alert('活动商品下的套餐折扣不能为0', 'warning');
                                isStop = true;
                                return false;
                            }
                        }

                        if (item.iProductNum == null) {
                            cb.utils.alert('活动商品下的数量不能为空', 'warning');
                            isStop = true;
                            return false;
                        }

                        if (isDecimals) {
                            item.iProductNum = parseInt(item.iProductNum);
                        }

                        if (item.iProductNum == 0) {
                            cb.utils.alert('活动商品下的数量不能为小于1', 'warning');
                            isStop = true;
                            return false;
                        }

                    }
                    if (isStop) {
                        return false;
                    }
                }

                if (this.get('combinationActiveTag').getRows().length > 0) {
                    //促销标签列表数据不为空
                    for (let i = 0; i < this.get('combinationActiveTag').getRows().length; i++) {
                        let item = this.get('combinationActiveTag').getRows()[i];
                        if (this.get('iPackageDiscountSelect').getValue() == 'false' || this.get('iPackageDiscountSelect').getValue() == false) {
                            //“套餐价设置方式”选择的为“套餐价”
                            if (item.tagPrice == 0) {
                                cb.utils.alert('促销标签下的套餐价不能为0', 'warning');
                                isStop = true;
                                return false;
                            }
                        }
                        if (this.get('iPackageDiscountSelect').getValue() == 'true' || this.get('iPackageDiscountSelect').getValue() == true) {
                            //“套餐价设置方式”选择的为“套餐折扣”
                            if (item.tagPrice == 0) {
                                cb.utils.alert('促销标签下的数量不能为0', 'warning');
                                isStop = true;
                                return false;
                            }
                        }

                        if (item.type == 0) {
                            cb.utils.alert('促销标签下的数量不能为0', 'warning');
                            isStop = true;
                            return false;
                        }
                    }
                }

                //有主商品的套餐价活动计算金额权重
                totalRate = Number(totalRate.toFixed(2));
                if (null != obj.mainProductId && obj.iPackageDiscountSelect == "false"
                    && totalRate != 100 && (false == obj.mainPriceFromSub || "false" == obj.mainPriceFromSub)) {
                    cb.utils.alert('金额权重相加应等于100', 'warning');
                    return false;
                }

                if (obj.mainProductId != null && obj.mainProductId_price != null) {
                    obj.PackageDiscountDrice = obj.mainProductId_price;
                }

                //处理促销维度是标签还是商品
                if (null != obj.combinationActiveTag && obj.combinationActiveTag.length > 0) {
                    obj.bTag = 1;
                } else {
                    obj.bTag = 0;
                }

                data.data.data = JSON.stringify(obj);

            });

            const displayIsGetmemberPrice = (viewmodel) => {
                if (viewmodel.get("memberLevelAll").getValue() == 0 && viewmodel.get("combinationsalesmemberlevel").getShowValue()
                    && viewmodel.get("combinationsalesmemberlevel").getShowValue().length == 1) {
                    viewmodel.get("isGetmemberPrice").setDisabled(false);
                } else {
                    viewmodel.get("isGetmemberPrice").setValue(false);
                    viewmodel.get("isGetmemberPrice").setDisabled(true);
                }
            }

            const isDisabledMainProduct = (value) => {
                if (value) {
                    if ((viewmodel.get('mainProductId').getValue() == null)
                        && (viewmodel.get('combinationProducts').getRowsCount() > 0 || viewmodel.get('combinationActiveTag').getRowsCount() > 0)) {
                        viewmodel.get('mainProduct_Name').setDisabled(true);
                    } else {
                        viewmodel.get('mainProduct_Name').setDisabled(false);
                    }
                } else {
                    if ((viewmodel.get('mainProductId').getValue() == null)
                        && (viewmodel.get('combinationProducts').getRowsCount() > 0)) {
                        viewmodel.get('mainProduct_Name').setDisabled(true);
                    } else {
                        viewmodel.get('mainProduct_Name').setDisabled(false);
                    }
                }
            }

            /**
             * 处理是否禁用选择主商品
             * @param viewmodel
             */
            const whetherToDisableMainProduct = (viewmodel) => {
                if ((viewmodel.get('mainProductId').getValue() == null)
                    && (viewmodel.get('combinationProducts').getRowsCount() > 0 || viewmodel.get('combinationActiveTag').getRowsCount() > 0)) {
                    viewmodel.get('mainProduct_Name').setDisabled(true);
                }
            }

            /**
             * 处理促销标签原价
             * @param data
             */
            const handlePromotionTagPrice = (data) => {

                var data = viewmodel.getAllData().combinationActiveTag;
                for (var i = 0; i < data.length; i++) {
                    // if (data[i].iminprice != 0) {
                    viewmodel.get('combinationActiveTag').setCellValue(i, 'price', data[i].iminprice + "~" + data[i].imaxprice);
                    // }

                }
                if (data.length > 0) viewmodel.get('totalPrice').setValue(getTagTotalPrice(viewmodel));

            }

            /**
             * 只有线下门店并且未选择主商品时才允许选择“套餐折扣”选项
             * @param isDisabled
             */
            const settintPackageDiscountSelect = (isDisabled) => {
                viewmodel.get('iPackageDiscountSelect').setState('dataSource', [
                    {value: "false", text: "套餐价", nameType: "text"},
                    {value: "true", text: "套餐折扣", nameType: "text", disabled: isDisabled}
                ]);
                if (isDisabled) {
                    viewmodel.get('iPackageDiscountSelect').setValue('false');
                    viewmodel.get('combinationProducts').setColumnState('proportion', 'visible', true);
                    viewmodel.get('combinationProducts').setColumnState('discountPackage', 'visible', false);
                }
            }

            /**
             * 删除table中的数据
             */
            const delPro = () => {
                if (viewmodel.get('combinationProducts').getData() && viewmodel.get('combinationProducts').getData().length > 0) {
                    let pricenums = viewmodel.get('combinationProducts').getRowsCount();
                    for (let i = pricenums - 1; i >= 0; i--) {
                        viewmodel.get('combinationProducts').deleteRows(i);
                    }
                }
            }

            /**
             * 删除Tag的table中的数据
             */
            const delTagPro = () => {
                if (viewmodel.get('combinationActiveTag').getData() && viewmodel.get('combinationActiveTag').getData().length > 0) {
                    let pricenums = viewmodel.get('combinationActiveTag').getRowsCount();
                    for (let i = pricenums - 1; i >= 0; i--) {
                        viewmodel.get('combinationActiveTag').deleteRows(i);
                    }
                }
            }

            /**
             * 处理套餐处理方式
             * @param viewmodel
             */
            const handleDiscountPackage = (viewmodel) => {

                //套餐设置方式选择“套餐价”
                if (viewmodel.get('iPackageDiscountSelect').getValue() == "false" ||
                    viewmodel.get('iPackageDiscountSelect').getValue() == false) {
                    viewmodel.get('combinationActiveTag').setColumnState('tagPrice', 'cShowCaption', "套餐价");

                    if (viewmodel.get('mainProductId').getValue() != null) {
                        //是否存在主商品，存在主商品则table显示金额权重
                        viewmodel.get('combinationProducts').setColumnState('proportion', 'visible', true);
                        viewmodel.get('combinationProducts').setColumnState('discountPackage', 'visible', false);
                        viewmodel.get('combinationProducts').setColumnState('favorablePrice', 'visible', false);
                        //显示套餐原价,隐藏其他控件
                        viewmodel.get('totalPrice').setVisible(true);
                        viewmodel.get('PackageDiscountDrice').setVisible(false);
                        viewmodel.get('btnBatchEdit').setVisible(false);
                        viewmodel.get('iPackageLimitNum').setVisible(false);
                        viewmodel.get('iPackageLimitNum2').setVisible(false);
                    } else {
                        //不存在主商品，table显示套餐价
                        viewmodel.get('combinationProducts').setColumnState('proportion', 'visible', false);
                        viewmodel.get('combinationProducts').setColumnState('discountPackage', 'visible', false);
                        viewmodel.get('combinationProducts').setColumnState('favorablePrice', 'visible', true);
                        //显示套餐原价、套餐价、限购类型、限购数量,隐藏其他控件
                        viewmodel.get('totalPrice').setVisible(true);
                        viewmodel.get('PackageDiscountDrice').setVisible(true);
                        viewmodel.get('btnBatchEdit').setVisible(false);
                        viewmodel.get('iPackageLimitNum').setVisible(true);
                        //判断是否展示限购数量
                        isDisplayPackageLimitNum2(viewmodel.get('iPackageLimitNum').getValue());
                    }
                } else if (viewmodel.get('iPackageDiscountSelect').getValue() == "true" ||
                    viewmodel.get('iPackageDiscountSelect').getValue() == true) {
                    //套餐设置方式选择“套餐折扣”，table展示折扣价
                    viewmodel.get('combinationProducts').setColumnState('proportion', 'visible', false);
                    viewmodel.get('combinationProducts').setColumnState('discountPackage', 'visible', true);
                    viewmodel.get('combinationProducts').setColumnState('favorablePrice', 'visible', false);
                    viewmodel.get("combinationProducts").getEditRowModel().get('discountPackage').setState('min', 0);
                    viewmodel.get("combinationProducts").getEditRowModel().get('discountPackage').setState('max', 10);
                    viewmodel.get('combinationActiveTag').setColumnState('tagPrice', 'cShowCaption', "套餐折扣");

                    if (viewmodel.get('mainProductId').getValue() != null) {
                        //存在主商品，只显示套餐原价和套餐折扣
                        viewmodel.get('totalPrice').setVisible(true);
                        viewmodel.get('PackageDiscountDrice').setVisible(false);
                        viewmodel.get('btnBatchEdit').setVisible(true);
                        viewmodel.get('iPackageLimitNum').setVisible(false);
                        viewmodel.get('iPackageLimitNum2').setVisible(false);
                    } else {
                        //不存在主商品
                        viewmodel.get('totalPrice').setVisible(true);
                        viewmodel.get('PackageDiscountDrice').setVisible(false);
                        viewmodel.get('btnBatchEdit').setVisible(true);
                        viewmodel.get('iPackageLimitNum').setVisible(true);
                        //判断是否展示限购数量
                        isDisplayPackageLimitNum2(viewmodel.get('iPackageLimitNum').getValue());
                    }
                }
                //商品原价显示
                viewmodel.get('totalPrice').setValue(getTotalPrice(viewmodel));

            }

            const isDisplayPackageLimitNum2 = (value) => {
                if (value != 4) {
                    viewmodel.get('iPackageLimitNum2').setVisible(false);
                } else {
                    viewmodel.get('iPackageLimitNum2').setVisible(true);
                }
            }
            const isDisplayTagTable = () => {
                if (viewmodel.get('applyOnlineChannel').getValue() == 0 && viewmodel.get('applyOffLineChannel').getValue() == 1) {
                    handleLineTableDiv(true);
                } else if (viewmodel.get('applyOnlineChannel').getValue() == 1 && viewmodel.get('applyOffLineChannel').getValue() == 0) {
                    handleLineTableDiv(false);
                } else if (viewmodel.get('applyOnlineChannel').getValue() == 1 && viewmodel.get('applyOffLineChannel').getValue() == 1) {
                    handleLineTableDiv(false);
                }
            }

            //处理适用渠道相关逻辑
            const dealApplyOnlineChannel = () => {

                viewmodel.get('iSendPoint').setVisible(true);
                if (viewmodel.get('applyOnlineChannel').getValue() == 0 && viewmodel.get('applyOffLineChannel').getValue() == 1) {
                    viewmodel.get('applicableChannel').setValue(["1"]);
                    viewmodel.get('mainPriceFromSub').setVisible(true);
                    viewmodel.get('subProductMustOnSale').setVisible(true);
                    viewmodel.get("iPackageLimitNum2").setState('iNumPoint', 2);
                    settintPackageDiscountSelect(viewmodel.get("mainProductId").getValue());

                    //处理底部table显示问题
                    handleLineTableDiv(true);

                } else if (viewmodel.get('applyOnlineChannel').getValue() == 1 && viewmodel.get('applyOffLineChannel').getValue() == 0) {
                    viewmodel.get('iSendPoint').setVisible(false);
                    viewmodel.get('mainPriceFromSub').setVisible(false);
                    viewmodel.get('subProductMustOnSale').setVisible(false);
                    viewmodel.get('applicableChannel').setValue(["0"]);
                    viewmodel.get("iPackageLimitNum2").setState('iNumPoint', 0);
                    settintPackageDiscountSelect(true);

                    //处理底部table显示问题
                    handleLineTableDiv(false);

                } else if (viewmodel.get('applyOnlineChannel').getValue() == 1 && viewmodel.get('applyOffLineChannel').getValue() == 1) {
                    viewmodel.get('iSendPoint').setVisible(false);
                    viewmodel.get('mainPriceFromSub').setVisible(false);
                    viewmodel.get('subProductMustOnSale').setVisible(false);
                    viewmodel.get('applicableChannel').setValue(["0", "1"]);
                    viewmodel.get("iPackageLimitNum2").setState('iNumPoint', 0);
                    settintPackageDiscountSelect(true);

                    //处理底部table显示问题
                    handleLineTableDiv(false);

                }
            }

            /**
             * 处理底部table显示问题
             * @param isOnlyApplyOffLineChannel
             */
            const handleLineTableDiv = (isOnlyApplyOffLineChannel) => {

                if (viewmodel.getParams().mode == "browse") {
                    if (viewmodel.get("combinationProducts").getRowsCount() > 0) {
                        viewmodel.execute('updateViewMeta', {code: 'goodstab', visible: true});
                        viewmodel.execute('updateViewMeta', {code: 'tagstab', visible: false});
                    } else {
                        viewmodel.execute('updateViewMeta', {code: 'goodstab', visible: false});
                        viewmodel.execute('updateViewMeta', {code: 'tagstab', visible: true});
                    }
                } else {
                    if (isOnlyApplyOffLineChannel && (viewmodel.get('mainProductId').getValue() == ''
                        || viewmodel.get('mainProductId').getValue() == undefined)) {
                        if (viewmodel.get("combinationProducts").getRowsCount() > 0 || viewmodel.get('combinationActiveTag').getRowsCount() == 0) {
                            viewmodel.execute('updateViewMeta', {
                                code: 'goodstab',
                                visible: isOnlyApplyOffLineChannel,
                                active: true
                            });
                            viewmodel.execute('updateViewMeta', {
                                code: 'tagstab',
                                visible: isOnlyApplyOffLineChannel,
                                active: false
                            });
                        } else {
                            viewmodel.execute('updateViewMeta', {
                                code: 'goodstab',
                                visible: isOnlyApplyOffLineChannel,
                                active: false
                            });
                            viewmodel.execute('updateViewMeta', {
                                code: 'tagstab',
                                visible: isOnlyApplyOffLineChannel,
                                active: true
                            })
                        }
                    } else {
                        viewmodel.execute('updateViewMeta', {code: 'goodstab', visible: true});
                        viewmodel.execute('updateViewMeta', {code: 'tagstab', visible: false});
                    }
                }
            }

            /**
             * 设置控件最大最小值
             * @param view 控件
             * @param limitCategory 限制类型
             * @param limitNum 限制值
             */
            const setViewLimit = (view, limitCategory, limitNum) => {
                if (limitCategory == LIMIT_CATEGORY.MAX) {
                    view.setState('max', limitNum);
                } else {
                    view.setState('min', limitNum);
                }
            }

            const setViewLimits = () => {
                setViewLimit(viewmodel.get('iPackageLimitNum2'), LIMIT_CATEGORY.MIN, 0);
                setViewLimit(viewmodel.get('PackageDiscountDrice'), LIMIT_CATEGORY.MIN, 0);
                setViewLimit(viewmodel.get('combinationProducts').getEditRowModel().get('totalFavorablePrice'), LIMIT_CATEGORY.MIN, 0);
                setViewLimit(viewmodel.get('combinationProducts').getEditRowModel().get('favorablePrice'), LIMIT_CATEGORY.MIN, 0);
                setViewLimit(viewmodel.get('combinationProducts').getEditRowModel().get('iProductNum'), LIMIT_CATEGORY.MIN, 0);
                setViewLimit(viewmodel.get('combinationProducts').getEditRowModel().get('proportion'), LIMIT_CATEGORY.MAX, 100);
                setViewLimit(viewmodel.get('combinationProducts').getEditRowModel().get('discountPackage'), LIMIT_CATEGORY.MIN, 0);
                setViewLimit(viewmodel.get('combinationProducts').getEditRowModel().get('typeNum'), LIMIT_CATEGORY.MIN, 0);
                setViewLimit(viewmodel.get('combinationActiveTag').getEditRowModel().get('tagPrice'), LIMIT_CATEGORY.MIN, 0);
                setViewLimit(viewmodel.get('combinationActiveTag').getEditRowModel().get('type'), LIMIT_CATEGORY.MIN, 0);
            }

            /**
             * 判断是否包含主商品
             * @param value
             */
            const displayIsincludeMainProduct = (value) => {

                if (value != null) {

                    //选择主商品
                    viewmodel.get('combinationProducts').setColumnState('discountPackage', 'visible', true);
                    viewmodel.get('combinationProducts').setColumnState('favorablePrice', 'visible', false);
                    viewmodel.get('combinationProducts').setColumnState('sProductCode', 'bCanModify', false);
                    // viewmodel.get('combinationProducts').getEditRowModel().get('sProductCode').setReadOnly(true);
                    // viewmodel.get('combinationProducts').getEditRowModel().get('sProductCode').setDisabled(true);
                    viewmodel.get('totalPrice').setVisible(false);
                    viewmodel.get('PackageDiscountDrice').setVisible(false);
                    viewmodel.get('iPackageLimitNum').setVisible(false);
                    viewmodel.get('iPackageLimitNum2').setVisible(false);
                    viewmodel.get("iPackageLimitNum2").setState('iNumPoint', 0);

                    var alldata = getthisdata(viewmodel);
                    for (var j = 0; j < alldata.length; j++) {
                        viewmodel.get('combinationProducts').setCellValue(j, 'discountPackage', alldata[j].favorablePrice);

                    }
                    isDisplayTagTable();

                } else {

                    //未选择主商品
                    viewmodel.get('combinationProducts').setColumnState('discountPackage', 'visible', false);
                    viewmodel.get('combinationProducts').setColumnState('favorablePrice', 'visible', true);
                    viewmodel.get('combinationProducts').setColumnState('sProductCode', 'bCanModify', true);
                    // viewmodel.get('combinationProducts').getEditRowModel().get('sProductCode').setDisabled(false);
                    viewmodel.get('PackageDiscountDrice').setVisible(true);
                    viewmodel.get('iPackageLimitNum').setVisible(true);

                    var alldata = getthisdata(viewmodel);
                    var sum = 0;
                    for (var j = 0; j < alldata.length; j++) {
                        sum += alldata[j].price;
                    }
                    if (alldata.length > 0) {
                        viewmodel.get('totalPrice').setValue(sum);
                    } else {
                        viewmodel.get('totalPrice').setValue(getTagTotalPrice(viewmodel));
                    }
                    isDisplayTagTable();
                }
            }

            const displayMainType = (viewmodel) => {
                let mainType = viewmodel.get("mainType").getValue();
                //商品
                if (mainType == 1) {
                    viewmodel.get('mainProduct_Name').setVisible(true);
                    viewmodel.get('mainProductId_price').setVisible(true);
                    viewmodel.get('mainProductId_modelDescription').setVisible(true);
                    viewmodel.get('mainProductId_url').setVisible(true);
                    viewmodel.get('mainProductCode').setVisible(true);
                    viewmodel.get('iskuId_Name').setVisible(false);
                    viewmodel.get('iskuId_price').setVisible(false);
                    viewmodel.get('skuDescription').setVisible(false);
                    viewmodel.get('iskuId_url').setVisible(false);
                    viewmodel.get('iskuId_Code').setVisible(false);
                } else {
                    viewmodel.get('mainProduct_Name').setVisible(false);
                    viewmodel.get('mainProductId_price').setVisible(false);
                    viewmodel.get('mainProductId_modelDescription').setVisible(false);
                    viewmodel.get('mainProductId_url').setVisible(false);
                    viewmodel.get('mainProductCode').setVisible(false);
                    viewmodel.get('iskuId_Name').setVisible(true);
                    viewmodel.get('iskuId_price').setVisible(true);
                    viewmodel.get('skuDescription').setVisible(true);
                    viewmodel.get('iskuId_url').setVisible(true);
                    viewmodel.get('iskuId_Code').setVisible(true);
                }
            }

            const displayMainTypeControl = (viewmodel) => {
                if (viewmodel.get('applyOffLineChannel').getValue() == 1) {
                    viewmodel.get("mainType").setVisible(false);
                } else {
                    viewmodel.get("mainType").setVisible(true);
                }
            }

            const clearMainType = (viewmodel) => {
                viewmodel.get('iskuId_Name').setValue(null);
                viewmodel.get('iskuId_price').setValue(null);
                viewmodel.get('skuDescription').setValue(null);
                viewmodel.get('iskuId_url').setValue(null);
                viewmodel.get("iskuId").setValue(null);
                viewmodel.get("iskuId_Code").setValue(null);
                viewmodel.get('mainProductId').setValue(null);
                viewmodel.get("mainProductCode").setValue(null);
                viewmodel.get('mainProduct_Name').setValue(null);
                viewmodel.get('mainProductId_price').setValue(null);
                viewmodel.get('mainProductId_modelDescription').setValue(null);
                viewmodel.get('mainProductId_url').setValue(null);
            }

        }
    };
    try {
        module.exports = PM_pmc_fixedsales_VM_Extend;
    } catch (error) {

    }
    return PM_pmc_fixedsales_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/PM/PM_pmc_fixedsales_VM.Extend.js